const translations: Record<string, string> = {
  'common:siteName': '免費PDF工具',
  'common:nav.home': '首頁',
  'common:nav.pdfToWord': 'PDF轉Word',
  'common:nav.pdfToExcel': 'PDF轉Excel',
  'common:nav.pdfToPpt': 'PDF轉PPT',
  'common:nav.imageConvert': '圖片轉換',
  'common:nav.pdfTools': 'PDF工具',
  'common:nav.tutorials': '使用教學',
  'common:nav.faq': '常見問題',

  'common:footer.description': '最好的免費PDF工具，滿足您所有的PDF轉換和編輯需求。無需註冊。',
  'common:footer.quickLinks': '快速連結',
  'common:footer.about': '關於',
  'common:footer.aboutUs': '關於我們',
  'common:footer.tutorials': '教學',
  'common:footer.faq': '常見問題',
  'common:footer.privacyPolicy': '隱私政策',
  'common:footer.subscribe': '訂閱',
  'common:footer.subscribeNote': '獲取最新技巧和更新。',
  'common:footer.subscribePlaceholder': '輸入您的電子郵件',
  'common:footer.subscribeButton': '訂閱',
  'common:footer.subscribing': '訂閱中...',
  'common:footer.subscribeSuccess': '✓ 訂閱成功！',
  'common:footer.subscribeFailed': '訂閱失敗，請重試。',
  'common:footer.subscribeError': '網路錯誤，請重試。',
  'common:footer.adSpace': '廣告位',
  'common:footer.copyright': '© 2024 免費PDF工具。保留所有權利。',

  'common:features.pdfToDoc': 'PDF轉文件',
  'common:features.pdfToDocDesc': '將PDF轉換為Word、Excel、PPT等可編輯格式。',
  'common:features.imageToPdf': '圖片轉PDF',
  'common:features.imageToPdfDesc': '輕鬆將多張圖片合併為一個PDF檔案。',
  'common:features.pdfMerge': '合併與拆分PDF',
  'common:features.pdfMergeDesc': '合併多個PDF或將一個PDF拆分為多個檔案。',
  'common:features.startConvert': '開始轉換',
  'common:features.useNow': '立即使用',
  'common:features.mostPopular': '最受歡迎',

  'home:hero.title': '免費線上PDF工具',
  'home:hero.subtitle': '輕鬆轉換、編輯和管理您的PDF檔案。無需註冊，100%免費！',
  'home:hero.free': '永久免費',
  'home:hero.noRegistration': '無需註冊',
  'home:hero.secure': '安全私密',
  'home:hero.startConverting': '開始轉換',
  'home:hero.viewAllTools': '查看所有工具',
  'home:hero.stats.users': '滿意用戶',
  'home:hero.stats.conversions': '已轉換檔案',
  'home:hero.stats.rating': '用戶評分',

  'home:allTools.title': '所有PDF工具',
  'home:allTools.subtitle': '處理PDF檔案所需的一切，完全免費。',
  'home:allTools.tryNow': '立即試用',
  'home:tools.pdfToWord.name': 'PDF轉Word',
  'home:tools.pdfToWord.description': '將PDF轉換為可編輯的Word文件。',
  'home:tools.pdfToExcel.name': 'PDF轉Excel',
  'home:tools.pdfToExcel.description': '從PDF中提取表格到Excel試算表。',
  'home:tools.pdfToPpt.name': 'PDF轉PPT',
  'home:tools.pdfToPpt.description': '將PDF轉換為PowerPoint簡報。',
  'home:tools.pdfToImage.name': 'PDF轉圖片',
  'home:tools.pdfToImage.description': '將PDF頁面轉換為JPG或PNG圖片。',
  'home:tools.imageToPdf.name': '圖片轉PDF',
  'home:tools.imageToPdf.description': '將圖片合併為一個PDF檔案。',
  'home:tools.mergePdf.name': '合併PDF',
  'home:tools.mergePdf.description': '將多個PDF檔案合併為一個。',
  'home:tools.splitPdf.name': '拆分PDF',
  'home:tools.splitPdf.description': '從PDF檔案中提取頁面。',
  'home:tools.compressPdf.name': '壓縮PDF',
  'home:tools.compressPdf.description': '在不損失品質的情況下減小PDF檔案大小。',

  'home:whyUs.title': '為什麼選擇我們？',
  'home:whyUs.subtitle': '我們提供最好的免費PDF工具，無隱藏費用，無需註冊。',
  'home:whyUs.free.title': '100%免費',
  'home:whyUs.free.description': '所有工具完全免費。沒有隱藏費用，沒有訂閱。',
  'home:whyUs.fast.title': '極速處理',
  'home:whyUs.fast.description': '我們的伺服器在幾秒鐘內處理您的檔案。',
  'home:whyUs.secure.title': '安全私密',
  'home:whyUs.secure.description': '轉換後您的檔案會自動刪除。',
  'home:whyUs.easy.title': '簡單易用',
  'home:whyUs.easy.description': '簡單的拖放介面，無需任何技術技能。',
  'home:whyUs.cta.title': '準備好開始了嗎？',
  'home:whyUs.cta.description': '加入每天信任我們免費PDF工具的數百萬用戶。',
  'home:whyUs.cta.button': '免費試用',

  'home:testimonials.title': '用戶評價',
  'home:testimonials.subtitle': '受到全球數百萬用戶的信賴。',
  'home:testimonials.trustedBy': '受信任並認證於',
  'home:testimonials.badges.secure': 'SSL安全',
  'home:testimonials.badges.verified': '已驗證安全',
  'home:testimonials.badges.award': '頂級工具',
  'home:testimonials.user1.name': 'Sarah Johnson',
  'home:testimonials.user1.role': '行銷經理',
  'home:testimonials.user1.content': '這是我用過最好的免費PDF工具。快速、可靠，不需要煩人的註冊！',
  'home:testimonials.user2.name': 'Emily Chen',
  'home:testimonials.user2.role': '自由設計師',
  'home:testimonials.user2.content': '我每天為客戶將PDF轉換為Word。這個工具節省了我很多時間，而且完全免費！',
  'home:testimonials.user3.name': 'Michael Torres',
  'home:testimonials.user3.role': '業務分析師',
  'home:testimonials.user3.content': 'PDF轉Excel功能非常準確，每次都能完美提取表格。',

  'home:ads.topBanner': '廣告',
  'home:ads.middleBanner': '廣告',

  'upload:dragDrop': '拖放您的PDF檔案到這裡',
  'upload:or': '或',
  'upload:selectFile': '選擇檔案',
  'upload:processing': '處理中...',
  'upload:converting': '正在轉換您的檔案...',
  'upload:done': '完成！',
  'upload:success': '您的檔案已成功轉換',
  'upload:download': '下載檔案',
  'upload:convertAnother': '轉換其他檔案',
  'upload:fileSize': '最大檔案大小：10MB',
  'upload:supportedFormats': '支援的格式',

  'pdfToWord:title': 'PDF轉Word',
  'pdfToWord:description': '免費將您的PDF檔案轉換為可編輯的Word文件',
  'pdfToWord:feature1.title': '快速轉換',
  'pdfToWord:feature1.desc': '幾秒鐘內將PDF轉換為Word',
  'pdfToWord:feature2.title': '高品質',
  'pdfToWord:feature2.desc': '保留原始格式和版面',
  'pdfToWord:feature3.title': '100%免費',
  'pdfToWord:feature3.desc': '無需註冊或付費',
  'pdfToWord:howTo.title': '使用方法',
  'pdfToWord:howTo.step1': '上傳您的PDF檔案',
  'pdfToWord:howTo.step2': '等待轉換完成',
  'pdfToWord:howTo.step3': '下載您的Word檔案',

  'pdfToExcel:title': 'PDF轉Excel',
  'pdfToExcel:description': '將PDF表格轉換為可編輯的Excel試算表',
  'pdfToExcel:feature1.title': '提取表格',
  'pdfToExcel:feature1.desc': '自動從PDF中提取表格',
  'pdfToExcel:feature2.title': '資料準確',
  'pdfToExcel:feature2.desc': '保留原始資料結構',
  'pdfToExcel:feature3.title': '易於使用',
  'pdfToExcel:feature3.desc': '簡單直觀的介面',
  'pdfToExcel:howTo.title': '使用方法',
  'pdfToExcel:howTo.step1': '上傳包含表格的PDF檔案',
  'pdfToExcel:howTo.step2': '系統將提取表格',
  'pdfToExcel:howTo.step3': '下載您的Excel檔案',

  'pdfToPpt:title': 'PDF轉PowerPoint',
  'pdfToPpt:description': '將您的PDF轉換為可編輯的PowerPoint簡報',
  'pdfToPpt:feature1.title': '投影片轉換',
  'pdfToPpt:feature1.desc': '每個PDF頁面變成一個PPT投影片',
  'pdfToPpt:feature2.title': '可編輯',
  'pdfToPpt:feature2.desc': '轉換後可編輯文字和圖片',
  'pdfToPpt:feature3.title': '安全私密',
  'pdfToPpt:feature3.desc': '轉換後檔案將被刪除',
  'pdfToPpt:howTo.title': '使用方法',
  'pdfToPpt:howTo.step1': '選擇您的PDF檔案',
  'pdfToPpt:howTo.step2': '轉換為PPT格式',
  'pdfToPpt:howTo.step3': '下載您的簡報',

  'imageConvert:title': '圖片轉換器',
  'imageConvert:description': '輕鬆將圖片轉換為PDF或將PDF轉換為圖片',
  'imageConvert:feature1.title': '多格式支援',
  'imageConvert:feature1.desc': '支援JPG、PNG、BMP、GIF',
  'imageConvert:feature2.title': '批次轉換',
  'imageConvert:feature2.desc': '一次轉換多個圖片',
  'imageConvert:feature3.title': '品質保證',
  'imageConvert:feature3.desc': '圖片品質無損',
  'imageConvert:howTo.title': '使用方法',
  'imageConvert:howTo.step1': '上傳圖片或PDF',
  'imageConvert:howTo.step2': '選擇輸出格式',
  'imageConvert:howTo.step3': '下載轉換後的檔案',

  'pdfToolsPage:title': '完整PDF工具',
  'pdfToolsPage:description': '合併、拆分、壓縮和編輯您的PDF檔案',
  'pdfToolsPage:feature1.title': '合併PDF',
  'pdfToolsPage:feature1.desc': '將多個PDF合併為一個',
  'pdfToolsPage:feature2.title': '拆分PDF',
  'pdfToolsPage:feature2.desc': '從PDF中提取頁面',
  'pdfToolsPage:feature3.title': '壓縮PDF',
  'pdfToolsPage:feature3.desc': '減小PDF檔案大小',
  'pdfToolsPage:howTo.title': '使用方法',
  'pdfToolsPage:howTo.step1': '選擇您需要的工具',
  'pdfToolsPage:howTo.step2': '上傳您的PDF檔案',
  'pdfToolsPage:howTo.step3': '下載處理後的結果',

  'upload.downloading': '準備下載...',
  'upload.progress': '進度：{percent}%',
  'upload.dragDrop': '拖放您的PDF檔案到這裡',
  'upload.or': '或',
  'upload.selectFile': '選擇PDF檔案',
  'upload.fileSize': '最大檔案大小：20MB',
  'upload.uploading': '上傳中...',
  'upload.processing': '處理中...',
  'upload.converting': '轉換中...',
  'upload.preparing': '準備下載...',
  'upload.done': '轉換完成！',
  'upload.download': '下載',
  'upload.convertAnother': '轉換另一個檔案',
  'upload.convertedTo': '已轉換為',
  'upload.error': '轉換失敗',
  'upload.retry': '重試',
  'upload.selectAnother': '選擇另一個檔案',
  'upload.fileTooLarge': '檔案大小超過20MB限制',
  'upload.invalidFormat': '無效的檔案格式',
  'upload.networkError': '網路錯誤，請重試',
  'upload.conversionFailed': '轉換失敗，請重試',
  'upload.howItWorks': '如何使用',
  'upload.step1': '上傳檔案',
  'upload.step1Desc': '選擇或拖放您的PDF檔案',
  'upload.step2': '轉換',
  'upload.step2Desc': '我們自動處理您的檔案',
  'upload.step3': '下載',
  'upload.step3Desc': '立即獲取轉換後的檔案',

  'imageConvert.pdfToImage': 'PDF轉圖片',
  'imageConvert.imageToPdf': '圖片轉PDF',
  'imageConvert.selectImages': '選擇圖片',
  'imageConvert.multipleFilesHint': '支援多張圖片合併為一個PDF',
  'imageConvert.processingFiles': '正在處理 {count} 個檔案...',

  'pdfToPpt.feature1': '保留版面',
  'pdfToPpt.feature2': '保留圖片',
  'pdfToPpt.feature3': '可編輯簡報',
};

export default translations;
